module.exports = __webpack_public_path__ + "static/media/slider-previous-icon.42fb818d.svg";